module.exports = __webpack_public_path__ + "img/paired-banner.671ad34f.png";